import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/device_orders',
  component: Management,
  redirect: '/device_orders/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/device_orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listDeviceOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/device_orders/ListTable'),
          meta: {
            auth: Auth.listDeviceOrders,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/device_orders/DetailLayout'),
      meta: {
        auth: Auth.showDeviceOrder
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/device_orders/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showDeviceOrder
          }
        }
      ]
    }
  ]
}
